import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const FeatureDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Unique code")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("Created Date")} fieldName={"createdDate"} />
        </Col>
      </Row>
    </>
  );
};

export default FeatureDetailMain;
